import { defineComponent as _defineComponent } from 'vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsText from '@/components/vision/VsText.vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectionRequestConfirmationDialog',
  props: {
    hubName: null,
    orgName: null,
    autoConnect: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'close')
  (event: 'confirm')
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  hubName: string
  orgName: string
  autoConnect: boolean
}



const title = computed(() =>
  props.autoConnect ? 'Confirm connection ' : 'Confirm invitation'
)

const dialogText = computed(() => {
  const clientString =
    props.hubName === props.orgName
      ? props.hubName
      : `${props.orgName} - ${props.hubName}`

  if (props.autoConnect) {
    return `You can automatically connect to <b>${clientString}</b> without sending an invitation. Do you want to auto-connect now?`
  }

  return `<b>${clientString}</b> admins must accept your invitation before you can create jobs for them.`
})

const buttonText = computed(() => (props.autoConnect ? 'Connect' : 'Invite'))



const cancel = () => {
  emits('close')
}

const confirm = () => {
  emits('confirm')
}

return { __sfc: true,props, title, dialogText, buttonText, emits, cancel, confirm, VsButton, VsText }
}

})